export enum REPORTS_SECTIONS_ROUTES {
  MGA = 'report',
  MGA_REAL_MONEY_BALANCE = 'real-money-balance',
}

export enum MGA_REPORT_PERMISSIONS {
  REPORT_PERMISSION_GET_MGA_REPORT = 'backofficeapi_report_get_mga_report',
  REPORT_PERMISSION_GET_MGA_REPORT_CSV = 'backofficeapi_report_get_mga_report_csv',
  REPORT_PERMISSION_GET_TIMESTAMP = 'backofficeapi_report_get_timestamp',
}

export enum MGA_REAL_MONEY_BALANCE_PERMISSIONS {
  REPORT_PERMISSION_GET_MGA_PLAYER_TIMESTAMP = 'backofficeapi_report_get_timestamp',
  REPORT_PERMISSION_GET_MGA_PLAYER_REPORT = 'backofficeapi_report_get_mga_player_report',
  REPORT_PERMISSION_GET_MGA_PLAYER_REPORT_CSV = 'backofficeapi_report_get_mga_player_report_csv',
}

export type ReportsPermissions = {
  [REPORTS_SECTIONS_ROUTES.MGA]: { [key in MGA_REPORT_PERMISSIONS]: boolean };
  [REPORTS_SECTIONS_ROUTES.MGA_REAL_MONEY_BALANCE]: { [key in MGA_REAL_MONEY_BALANCE_PERMISSIONS]: boolean };
};
